import React from 'react';
import ReactDOM from 'react-dom';
import className from 'classnames';

class Modal extends React.Component {
  static propTypes = {
  };

  static defaultProps = {
  };

  state = {
  };

  render = () => {
    return ReactDOM.createPortal(
      (
        <div
          className={className('Modal', {
            'Modal--active': this.props.isActive,
            [`${this.props.klassName}`]: this.props.klassName,
          })}
        >
          <a
            className='Modal__overlay'
            onClick={this.props.onToggleModal}
          />

          <div className='Modal__wrapper'>
            {this.props.children}
          </div>
        </div>
      ),
      document.querySelector('#modals')
    )
  }
}

export default Modal;
